import React from "react";
import "./ImageWithText.css";
import { Container, Button, Typography } from "@material-ui/core";
import productBuoy from '../../photos/productBuoy2.svg';

function ImageWithText() {
  return (
    <div className="image-with-text-container">
      <div className="image-container">
        <img src={require("./Employees/photos/Olesia2.jpg").default} alt="Olesia" />
      </div>
      <div className="text-container">
        <div className="center-text"> {/* Додано контейнер для центрування тексту */}
          <h1>Вдовенко Леся Олександрівна</h1>
          <p>
            Головний бухгалтер підприємства. Безперебійний та надійних супровід документообігу.
          </p>
          <Container component="section">
            
          </Container>
        </div>
      </div>
    </div>
  );
}

export default ImageWithText;
